document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-countdown]').forEach((countdown) => {
    const end = new Date(countdown.dataset.endDate).getTime();
    const update = () => {
      const remaining = Math.max(0, end - Date.now());
      const seconds = Math.floor(remaining / 1000);
      const parts = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
      Object.entries(parts).forEach(([name, value]) => { const element = countdown.querySelector(`[data-${name}]`); if (element) element.textContent = String(value).padStart(2, '0'); });
    };
    update(); setInterval(update, 1000);
  });

  document.querySelectorAll('[data-browfi-product]').forEach((productRoot) => {
    const data = productRoot.querySelector('[data-browfi-variants]');
    if (!data) return;
    const variants = JSON.parse(data.textContent);
    const optionInputs = productRoot.querySelectorAll('[data-browfi-option]');
    const variantId = productRoot.querySelector('[data-browfi-variant-id]');
    const price = productRoot.querySelector('[data-browfi-price]');
    const compare = productRoot.querySelector('[data-browfi-compare]');
    const submit = productRoot.querySelector('[data-browfi-submit]');
    const form = productRoot.querySelector('[data-browfi-form]');
    const error = productRoot.querySelector('[data-browfi-error]');
    const savings = productRoot.querySelector('[data-browfi-savings]');
    const selectedTotal = productRoot.querySelector('[data-browfi-selected-total]');
    const upsells = [...productRoot.querySelectorAll('[data-browfi-upsell]')];
    const offers = [...productRoot.querySelectorAll('[data-source-offer]')];
    const shadeInputs = [...productRoot.querySelectorAll('[data-kit-shade]')];
    const shadeImages = JSON.parse(productRoot.querySelector('[data-shade-images]')?.textContent || '{}');
    const sticky = document.querySelector('[data-source-sticky-atc]');
    const stickySubmit = sticky?.querySelector('[data-sticky-submit]');
    const stickyShade = sticky?.querySelector('[data-sticky-shade]');
    const syncOffers = () => {
      offers.forEach((offer) => {
        const active = offer.querySelector('input[type="radio"]').checked;
        offer.classList.toggle('is-selected', active);
        offer.querySelector('.source-offer__shades').hidden = !active;
        const protection = offer.querySelector('.source-offer__protection');
        if (protection) protection.hidden = !active;
        offer.querySelectorAll('[data-browfi-upsell]').forEach((input) => {
          input.disabled = !active || pending || input.dataset.addonPurchasable !== 'true';
        });
        offer.querySelectorAll('[data-kit-shade]').forEach((select) => {
          select.disabled = !active || pending;
          const image = select.closest('label').querySelector('[data-shade-image]');
          if (shadeImages[select.value]) image.src = shadeImages[select.value];
        });
      });
    };
    let pending = false;
    const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
    const selectedOptions = () => [...optionInputs].reduce((selected, input) => {
      if (input.closest('[data-source-offer]') && !input.closest('[data-source-offer]').classList.contains('is-selected') && input.type !== 'radio') return selected;
      if (input.type !== 'radio' || input.checked) selected[Number(input.dataset.optionPosition) - 1] = input.value;
      return selected;
    }, {});
    const resolveVariant = () => {
      const selected = selectedOptions();
      return variants.find((item) => item.options.length === Object.keys(selected).length && item.options.every((value, index) => selected[index] === value));
    };
    const showError = (message = '') => {
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
    };
    const updateVariant = () => {
      const variant = resolveVariant();
      variantId.value = variant ? String(variant.id) : '';
      variantId.disabled = !variant?.available;
      if (price) price.firstChild.textContent = variant ? `${formatMoney(variant.price)} ` : 'Unavailable ';
      if (compare) compare.textContent = variant?.compare_at_price > variant?.price ? formatMoney(variant.compare_at_price) : '';
      if (savings) {
        savings.hidden = !(variant?.compare_at_price > variant?.price);
        savings.textContent = savings.hidden ? '' : `You're saving ${formatMoney(variant.compare_at_price - variant.price)} on this kit`;
      }
      if (selectedTotal) {
        const selectedUpsells = upsells.filter((input) => input.checked && input.dataset.addonPurchasable === 'true' && (!input.closest('[data-source-offer]') || input.closest('[data-source-offer]').classList.contains('is-selected')));
        selectedTotal.hidden = !variant || !selectedUpsells.length;
        selectedTotal.textContent = variant ? `Selected items: ${formatMoney(variant.price + selectedUpsells.reduce((total, input) => total + Number(input.dataset.price), 0))}` : '';
      }
      if (submit) {
        submit.disabled = pending || !variant?.available;
        submit.textContent = pending ? 'ADDING…' : !variant ? 'UNAVAILABLE' : variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      if (stickySubmit) {
        stickySubmit.disabled = submit.disabled;
        stickySubmit.textContent = pending ? 'ADDING…' : !variant ? 'UNAVAILABLE' : variant.available ? 'Add to cart' : 'SOLD OUT';
        sticky.querySelector('[data-sticky-price]').textContent = variant ? formatMoney(variant.price) : '';
        sticky.querySelector('[data-sticky-compare]').textContent = variant?.compare_at_price > variant?.price ? formatMoney(variant.compare_at_price) : '';
        if (variant) stickyShade.value = variant.option2;
      }
      return variant;
    };
    optionInputs.forEach((input) => input.addEventListener('change', () => { syncOffers(); showError(); updateVariant(); }));
    shadeInputs.forEach((input) => input.addEventListener('change', syncOffers));
    upsells.forEach((input) => {
      input.disabled = input.dataset.addonPurchasable !== 'true';
      input.addEventListener('change', updateVariant);
    });
    syncOffers();
    updateVariant();
    stickySubmit?.addEventListener('click', () => form.requestSubmit(submit));
    stickyShade?.addEventListener('change', () => {
      const primary = productRoot.querySelector('.source-offer.is-selected [data-kit-shade]');
      if (primary) { primary.value = stickyShade.value; primary.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    if (sticky && submit) {
      const syncSticky = () => {
        const shown = submit.getBoundingClientRect().bottom < 0;
        sticky.style.transform = shown ? 'none' : 'translateY(100%)';
        sticky.setAttribute('aria-hidden', String(!shown));
        sticky.inert = !shown;
      };
      window.addEventListener('scroll', syncSticky, { passive: true });
      window.addEventListener('resize', syncSticky);
      syncSticky();
    }
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (pending) return;
      const variant = updateVariant();
      if (!variant?.available) {
        showError(variant ? 'This option is sold out. Please choose another option.' : 'This combination is unavailable. Please choose another option.');
        return;
      }
      showError();
      const properties = {};
      for (const [name, value] of new FormData(form)) {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      }
      const items = [{ id: variant.id, quantity: 1, properties }];
      const freeGuide = productRoot.querySelector('[data-browfi-free-guide]');
      if (freeGuide?.value) items.push({ id: Number(freeGuide.value), quantity: 1 });
      upsells.filter((input) => input.checked && !input.disabled && input.dataset.addonPurchasable === 'true').forEach((input) => {
        const addonId = Number(input.dataset.variantId);
        if (Number.isSafeInteger(addonId) && addonId > 0 && !items.some((item) => item.id === addonId)) items.push({ id: addonId, quantity: 1 });
      });
      pending = true;
      const controls = [...new Set([...optionInputs, ...shadeInputs, ...upsells])];
      const disabledStates = controls.map((input) => input.disabled);
      controls.forEach((input) => { input.disabled = true; });
      form.setAttribute('aria-busy', 'true');
      updateVariant();
      try {
        const response = await fetch(productRoot.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add these items. Please check your cart and try again.');
        const added = new CustomEvent('browfi:cart-added', { bubbles: true, cancelable: true, detail: { items: result.items } });
        if (productRoot.dispatchEvent(added)) window.location.assign(productRoot.dataset.cartUrl);
      } catch (failure) {
        showError(failure instanceof TypeError ? 'We could not confirm the addition. Please check your cart before trying again.' : failure.message);
      } finally {
        pending = false;
        controls.forEach((input, index) => { input.disabled = disabledStates[index]; });
        form.removeAttribute('aria-busy');
        updateVariant();
      }
    });
    productRoot.querySelectorAll('[data-browfi-media-src],[data-browfi-media-html]').forEach((thumb) => {
      if (thumb.dataset.browfiMediaReady) return;
      thumb.dataset.browfiMediaReady = 'true';
      thumb.addEventListener('click', () => {
        const main = productRoot.querySelector('[data-browfi-main-media]');
        if (!main) return;
        main.innerHTML = thumb.dataset.browfiMediaHtml || `<img src="${thumb.dataset.browfiMediaSrc}" alt="${thumb.dataset.browfiMediaAlt || ''}" width="1600" height="1600" loading="eager">`;
        productRoot.querySelectorAll('.browfi-thumb').forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });
  });
  document.querySelectorAll('[data-review-lightbox]').forEach((dialog) => {
    const image = dialog.querySelector('[data-review-lightbox-image]');
    document.querySelectorAll('[data-review-image]').forEach((button) => button.addEventListener('click', () => {
      image.src = button.dataset.reviewImage;
      dialog.showModal();
    }));
    dialog.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  });
});
